import React ,{useEffect, useState} from "react";
import ComapnyList from "../../../entities/AccountSettings/CompanyList";
import AuthService from "../../../api/AuthService";
// import { useAlert } from "../../../context/AlertContext";
import LoaderHelper from "../../../utils/Loader/LoaderHelper";
// import { useLocation, useNavigate } from "react-router-dom"; 
import { useAlert } from "../../../context/AlertContext";
import { useNavigate } from "react-router-dom";



const CompanyList = () => {
  const [companyList, setCompanyList] = useState([]);
  const { showAlert } = useAlert();
  const [company, setCompany] = useState("");
  const [opens, setOpens] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    getCompanyList();
  },[])


  const getCompanyList = async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getCompantList();
      if (result?.success) {
        LoaderHelper.loaderStatus(false);
        setCompanyList(result?.data);
        checkCompany()
      } else {
        showAlert(result?.message, "error");
      }
    } catch (error) {
      showAlert(error, "error");
    }
  };

  const checkCompany = (id) => {
    if (companyList?.length > 0) {
      const value = companyList?.filter(item => item?._id === id)
      setCompany(value[0]?.companyName || "")
    }
  }

  const handleDeleteCompany = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.deleteCompany(id);
      if (result?.success === true) {
        LoaderHelper.loaderStatus(false);
        setOpens(false)
        showAlert(result?.message,"success")
        if(result?.data?.is_matched){
          localStorage.clear();
          navigate("/");
        }else{
          getCompanyList();
        }
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
        
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      showAlert(error,"error")
    }
  };

  return (
    <ComapnyList company={company} opens={opens} setOpens={setOpens} handleDeleteCompany={handleDeleteCompany} companyList={companyList}/>
  )

}

export default CompanyList;
